import React from "react";
import {useTable, usePagination, useGlobalFilter, useSortBy} from "react-table";
import {
  Table,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  IconButton,
} from "@mui/material";
import TableHeader from "./sub-components/TableHeader";
import {Edit, Delete} from "@mui/icons-material";
import TableFooter from "./sub-components/TableFooter";
import {impexDateFormat} from "../../manager/dateManager";
import {dateType} from "./cell/fields";
import TableHeaderLayout from "./sub-components/TableHeaderLayout";

function BasicTable({
  columns,
  data = [],
  fontSize,
  onUpdate,
  onDelete,
  pagination = false,
  tableFilter = false,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    state,
    setPageSize,
    canPreviousPage,
    setGlobalFilter,
    prepareRow,
    gotoPage,
    pageCount,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 12,
        hiddenColumns: columns
          .filter((col) => col.show === false)
          .map((col) => col.accessor),
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {pageIndex, pageSize, globalFilter} = state;

  return (
    <>
      {tableFilter && (
        <TableHeaderLayout
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
        />
      )}
      <TableContainer
        component={Paper}
        sx={{
          mb: 2,
        }}
      >
        <Table
          {...getTableProps()}
          sx={{
            borderCollapse: "separate",
            minWidth: "max-content",
          }}
        >
          <TableHeader headerGroups={headerGroups} />
          <TableBody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <TableRow
                  {...row.getRowProps()}
                  sx={{
                    "& td": {bgcolor: "background.paper", cursor: "pointer"},
                  }}
                >
                  {row.cells.map((cell) => {
                    if (cell.column.id === "update" && onUpdate) {
                      return (
                        <TableCell
                          {...cell.getCellProps()}
                          sx={{
                            fontSize: fontSize,
                          }}
                        >
                          <IconButton
                            onClick={() => {
                              onUpdate(cell.row.original);
                            }}
                          >
                            <Edit sx={{color: "#318CE7"}} />
                          </IconButton>
                        </TableCell>
                      );
                    } else if (cell.column.id === "delete") {
                      return (
                        <TableCell
                          {...cell.getCellProps()}
                          sx={{
                            fontSize: fontSize,
                          }}
                        >
                          <IconButton
                            onClick={() => {
                              onDelete(cell.row.original);
                            }}
                          >
                            <Delete sx={{color: "#FF0000"}} />
                          </IconButton>
                        </TableCell>
                      );
                    } else if (dateType.includes(cell.column.id)) {
                      return (
                        <TableCell
                          {...cell.getCellProps()}
                          sx={{
                            fontSize: fontSize,
                          }}
                        >
                          {impexDateFormat(cell.value)}
                        </TableCell>
                      );
                    }else if (cell.column.id === "IsMFA") {
                      return (
                        <TableCell
                          {...cell.getCellProps()}
                          sx={{
                            fontSize: fontSize,
                          }}
                        >
                          {(cell.value).toString()}
                        </TableCell>
                      );
                    }
                     else
                      return (
                        <TableCell
                          {...cell.getCellProps()}
                          sx={{
                            fontSize: fontSize,
                          }}
                        >
                          {cell.render("Cell")}
                        </TableCell>
                      );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {pagination && (
        <TableFooter
          canNextPage={canNextPage}
          canPreviousPage={canPreviousPage}
          pageOptions={pageOptions}
          pageIndex={pageIndex}
          nextPage={nextPage}
          previousPage={previousPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          gotoPage={gotoPage}
          pageCount={pageCount}
        />
      )}
    </>
  );
}

export default BasicTable;
